/* Refillia: carrello in un foglio che sale dal basso, al posto del cassetto di Horizon */
(function () {
  var box = document.getElementById('rfk');
  if (!box || box._rfk) return;
  box._rfk = true;
  var foglio = box.querySelector('[data-rfk-foglio]');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var anteprima = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' ? Shopify.theme.id : null;
  /* nell'anteprima del tema di lavoro la sezione va chiesta a quel tema */
  var URL_SEZ = root + 'cart?sections=rf-carrello' + (anteprima ? '&preview_theme_id=' + anteprima : '');
  var OM = [+box.dataset.om1 || 0, +box.dataset.om2 || 0];
  var PRIO = +box.dataset.prio || 0;
  var S1 = +box.dataset.s1 || 0, S2 = +box.dataset.s2 || 0;
  var pronto = false, prima = null, omPrima = null, giro = 0, ordine = {};
  var ridotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function chiedi(url, dati) {
    var opz = dati
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(dati) }
      : { headers: { Accept: 'application/json' }, cache: 'no-store' };
    return fetch(root + url, opz).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  /* ogni azione chiede anche la sezione del carrello: una sola richiesta invece di tre */
  function conSezione(dati) {
    var d = {};
    for (var k in dati) d[k] = dati[k];
    d.sections = 'rf-carrello';
    d.sections_url = root + 'cart';
    return d;
  }
  function sezione(j) { return j && j.sections && j.sections['rf-carrello']; }
  function metti(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    var nuovo = tmp.querySelector('[data-rfk-contenuto]');
    var vecchio = box.querySelector('[data-rfk-contenuto]');
    if (!nuovo || !vecchio) return false;
    var c0 = box.querySelector('[data-rfk-corpo]'), y = c0 ? c0.scrollTop : 0;
    vecchio.replaceWith(nuovo);
    var c1 = box.querySelector('[data-rfk-corpo]');
    if (c1) c1.scrollTop = y;
    pronto = true;
    box.classList.remove('is-carica');
    dopo();
    return true;
  }
  function usa(j) { return metti(sezione(j)) ? null : carica(); }

  /* omaggi: si aggiungono e si tolgono da soli in base a quanto si paga (costano 0 €) */
  function omaggi() {
    var s = box.querySelector('[data-rfk-stato]');
    if (!s) return Promise.resolve();
    var pagato = +s.dataset.pagato, o1 = +s.dataset.om1, o2 = +s.dataset.om2, prodotti = +s.dataset.prodotti, pr = +s.dataset.prio;
    var voglio = [OM[0] && pagato >= S1 ? 1 : 0, OM[1] && pagato >= S2 ? 1 : 0], ho = [o1, o2];
    var cambi = {}, nuovi = [], serve = false;
    [0, 1].forEach(function (i) {
      if (!OM[i] || voglio[i] === ho[i]) return;
      serve = true;
      if (ho[i] === 0) nuovi.push({ id: OM[i], quantity: 1 });
      else cambi[OM[i]] = voglio[i];
    });
    /* senza prodotti la spedizione prioritaria non ha senso */
    if (!prodotti && pr && PRIO) { cambi[PRIO] = 0; serve = true; }
    if (!serve) return Promise.resolve();
    var passo = Promise.resolve(null);
    if (Object.keys(cambi).length) passo = passo.then(function () { return chiedi('cart/update.js', conSezione({ updates: cambi })); });
    if (nuovi.length) passo = passo.then(function () { return chiedi('cart/add.js', conSezione({ items: nuovi })); });
    return passo.then(usa).catch(function () { return carica(); });
  }
  function azione(url, dati) {
    box.classList.add('is-carica');
    return chiedi(url, conSezione(dati)).then(usa).then(omaggi).catch(function () { return aggiorna(); });
  }

  function mescola() {
    box.querySelectorAll('[data-rfk-ups]').forEach(function (u) {
      var carte = Array.prototype.slice.call(u.querySelectorAll('[data-rfk-up]'));
      carte.forEach(function (c) { var k = c.querySelector('[data-rfk-agg]').dataset.rfkAgg; if (!(k in ordine)) ordine[k] = Math.random(); });
      carte.sort(function (a, b) { return ordine[a.querySelector('[data-rfk-agg]').dataset.rfkAgg] - ordine[b.querySelector('[data-rfk-agg]').dataset.rfkAgg]; });
      var n = carte.length, da = n > 4 ? (giro * 4) % n : 0;
      var vis = [];
      for (var i = 0; i < Math.min(4, n); i++) vis.push(carte[(da + i) % n]);
      carte.forEach(function (c) { c.hidden = vis.indexOf(c) < 0; });
      vis.forEach(function (c) { c.parentNode.appendChild(c); });
      var g = u.querySelector('[data-rfk-giro]');
      if (g) g.hidden = n <= 4;
    });
  }

  var tAvv = null;
  function avviso(testo) {
    var a = box.querySelector('[data-rfk-avviso]');
    if (!a) return;
    a.innerHTML = '<i><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.5-3.5-5.5-3.5-5.5-1S10 8 12 8zM12 8c1.5-3.5 5.5-3.5 5.5-1S14 8 12 8z"/></svg></i>' + testo;
    a.classList.add('on');
    clearTimeout(tAvv);
    tAvv = setTimeout(function () { a.classList.remove('on'); }, 2800);
  }

  function dopo() {
    mescola();
    var c = box.querySelector('[data-rfk-conta]');
    var n = c ? +c.dataset.rfkConta : 0;
    document.querySelectorAll('cart-icon').forEach(function (ic) {
      if (typeof ic.renderCartBubble === 'function') ic.renderCartBubble(n, false);
    });
    var p = box.querySelector('[data-rfk-omaggi]');
    var om = p ? +p.dataset.rfkOmaggi : 0;
    if (omPrima !== null && om > omPrima) {
      avviso(om >= 2 ? 'Sbloccato: 5 mini profumi tester in omaggio' : 'Sbloccato: Deo Tessuti in omaggio');
      p.classList.add('festa');
    }
    omPrima = om;
  }

  function carica() {
    return fetch(URL_SEZ, { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (j) {
      metti(j['rf-carrello']);
    });
  }
  function aggiorna() {
    box.classList.add('is-carica');
    return carica().then(omaggi).catch(function () { box.classList.remove('is-carica'); });
  }

  function apri(senzaCarica) {
    if (!box.hidden && box.classList.contains('is-aperto')) return;
    prima = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('rfk-bloccato');
    void foglio.offsetWidth;
    box.classList.add('is-aperto');
    if (!pronto && !senzaCarica) aggiorna();
    var x = box.querySelector('[data-rfk-chiudi].rfk__x');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
  }
  function chiudi() {
    box.classList.remove('is-aperto');
    foglio.style.transform = '';
    document.documentElement.classList.remove('rfk-bloccato');
    setTimeout(function () { if (!box.classList.contains('is-aperto')) box.hidden = true; }, 430);
    if (prima && prima.focus) prima.focus({ preventScroll: true });
  }

  /* pallino che vola verso il carrello della testata */
  function vola(da, poi) {
    var meta = Array.prototype.slice.call(document.querySelectorAll('#header-component cart-icon')).filter(function (e) { return e.offsetParent; })[0];
    if (!da || !meta || ridotto) { poi(); return; }
    var a = da.getBoundingClientRect(), b = meta.getBoundingClientRect();
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var d = document.createElement('i');
    d.className = 'rfk-volo';
    d.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>';
    document.body.appendChild(d);
    var t0 = null, durata = 480, alto = Math.min(y0, y1) - 120;
    function passo(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / durata), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      var x = x0 + (x1 - x0) * e, y = (1 - e) * (1 - e) * y0 + 2 * (1 - e) * e * alto + e * e * y1;
      d.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + (1 - 0.45 * e) + ')';
      if (k < 1) requestAnimationFrame(passo);
      else {
        d.remove();
        meta.classList.remove('rfk-salta');
        void meta.offsetWidth;
        meta.classList.add('rfk-salta');
        poi();
      }
    }
    requestAnimationFrame(passo);
    /* se la scheda è in background il pallino non parte: si va avanti lo stesso */
    setTimeout(function () { if (d.isConnected) { d.remove(); poi(); poi = function () {}; } }, 1100);
  }

  function bollaPiu(n) {
    document.querySelectorAll('cart-icon').forEach(function (ic) {
      if (typeof ic.renderCartBubble !== 'function') return;
      var ora = parseInt((ic.querySelector('.cart-bubble__text-count') || {}).textContent || '0', 10) || 0;
      ic.renderCartBubble(ora + n, false);
    });
  }
  /* il pallino parte subito, la richiesta va in parallelo: il carrello si apre appena atterra */
  function aggiungiCon(richiesta, da, quanti) {
    bollaPiu(quanti || 1);
    box.classList.add('is-carica');
    var volo = new Promise(function (ok) { vola(da, ok); });
    volo.then(function () { apri(true); });
    return Promise.all([richiesta, volo]).then(function (r) { return usa(r[0]); }).then(omaggi).catch(function (err) {
      box.classList.remove('is-carica');
      avviso((err && (err.description || err.message)) || 'Non è stato possibile aggiungere il prodotto.');
      return carica();
    });
  }
  function aggiungi(id, da) {
    return aggiungiCon(chiedi('cart/add.js', conSezione({ items: [{ id: +id, quantity: 1 }] })), da, 1);
  }
  window.RfCarrello = { apri: apri, chiudi: chiudi, aggiorna: aggiorna, aggiungi: aggiungi };

  /* clic dentro il carrello */
  box.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t) return;
    if (t.hasAttribute('data-rfk-chiudi')) { chiudi(); return; }
    var riga = t.closest('[data-key]');
    if (t.hasAttribute('data-rfk-qt') && riga) {
      azione('cart/change.js', { id: riga.dataset.key, quantity: +t.dataset.rfkQt });
      return;
    }
    if (t.hasAttribute('data-rfk-dopo') && riga) {
      if (window.RfPref) window.RfPref.aggiungi(t.dataset.rfkDopo);
      azione('cart/change.js', { id: riga.dataset.key, quantity: 0 });
      return;
    }
    if (t.hasAttribute('data-rfk-prio')) {
      var su = t.getAttribute('aria-checked') !== 'true';
      t.setAttribute('aria-checked', su ? 'true' : 'false');
      if (su) azione('cart/add.js', { items: [{ id: PRIO, quantity: 1 }] });
      else azione('cart/update.js', { updates: (function () { var u = {}; u[PRIO] = 0; return u; })() });
      return;
    }
    if (t.hasAttribute('data-rfk-agg')) {
      var c = t.closest('[data-rfk-up]');
      t.classList.add('fatto');
      t.textContent = 'Aggiunto';
      if (c) setTimeout(function () { c.classList.add('via-ok'); }, 300);
      bollaPiu(1);
      azione('cart/add.js', { items: [{ id: +t.dataset.rfkAgg, quantity: 1 }] });
      return;
    }
    if (t.hasAttribute('data-rfk-giro')) { giro++; mescola(); return; }
    if (t.hasAttribute('data-rfk-togli-cod')) {
      azione('cart/update.js', { discount: '' });
      return;
    }
    if (t.hasAttribute('data-rfk-vai-cod')) {
      var corpo = box.querySelector('[data-rfk-corpo]'), giu = box.querySelector('[data-rfk-giu]');
      if (!corpo || !giu) return;
      corpo.scrollTo({ top: giu.getBoundingClientRect().top - corpo.getBoundingClientRect().top + corpo.scrollTop - 12, behavior: ridotto ? 'auto' : 'smooth' });
      setTimeout(function () {
        var f = giu.querySelector('.rfk__cod, .rfk__cod-ok');
        if (!f) return;
        f.classList.remove('rfk-luce');
        void f.offsetWidth;
        f.classList.add('rfk-luce');
        var i = f.querySelector('input');
        if (i) i.focus({ preventScroll: true });
      }, 450);
    }
  });

  /* codice sconto */
  box.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rfk-cod]');
    if (!f) return;
    e.preventDefault();
    var cod = (f.querySelector('input').value || '').trim();
    var errore = function (msg) {
      box.querySelectorAll('[data-rfk-cod-err]').forEach(function (p) { p.textContent = msg; p.hidden = false; });
    };
    if (!cod) { errore('Scrivi il codice e premi Applica.'); return; }
    box.classList.add('is-carica');
    chiedi('cart/update.js', conSezione({ discount: cod })).then(function (cart) {
      var trovato = (cart.discount_codes || []).filter(function (d) { return String(d.code).toLowerCase() === cod.toLowerCase(); })[0];
      if (trovato && trovato.applicable) return Promise.resolve(usa(cart)).then(omaggi);
      return chiedi('cart/update.js', conSezione({ discount: '' })).then(usa).then(function () {
        errore('Il codice “' + cod.toUpperCase() + '” non è valido o non si applica a questo carrello.');
      });
    }).catch(function () { box.classList.remove('is-carica'); errore('Non siamo riusciti a controllare il codice, riprova.'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box.classList.contains('is-aperto')) chiudi();
  });

  /* telefono: trascina giù la maniglia per chiudere */
  var man = box.querySelector('[data-rfk-maniglia]'), y0 = null, dy = 0;
  if (man) {
    man.addEventListener('pointerdown', function (e) { y0 = e.clientY; dy = 0; foglio.classList.add('is-trascina'); man.setPointerCapture(e.pointerId); });
    man.addEventListener('pointermove', function (e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); foglio.style.transform = 'translateY(' + dy + 'px)'; });
    var su = function () { if (y0 === null) return; foglio.classList.remove('is-trascina'); if (dy > 110) chiudi(); else foglio.style.transform = ''; y0 = null; };
    man.addEventListener('pointerup', su);
    man.addEventListener('pointercancel', su);
  }

  /* il carrello della testata e il "+" delle schede aprono il nostro */
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], #header-component a[href$="/cart"], [data-rf-apri-carrello], [data-rf-agg]');
    if (!t || box.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (t.hasAttribute('data-rf-agg')) {
      if (t.classList.contains('is-sta')) return;
      t.classList.add('is-sta');
      aggiungi(t.dataset.rfAgg, t).catch(function () {}).then(function () { t.classList.remove('is-sta'); });
      return;
    }
    apri();
  }, true);

  /* moduli "aggiungi al carrello" (scheda prodotto e altri): si aggiunge senza cambiare pagina */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || box.contains(f)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var bott = e.submitter || f.querySelector('[type="submit"]');
    if (bott) bott.setAttribute('aria-busy', 'true');
    var fd = new FormData(f);
    fd.append('sections', 'rf-carrello');
    fd.append('sections_url', root + 'cart');
    var q = +(fd.get('quantity') || 1) || 1;
    var rich = fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    aggiungiCon(rich, bott, q).then(function () { if (bott) bott.removeAttribute('aria-busy'); });
  }, true);

  /* aggiunte fatte dai moduli di Horizon (scheda prodotto, aggiunta rapida) */
  var origine = null;
  document.addEventListener('pointerdown', function (e) { origine = e.target.closest && e.target.closest('button, [type="submit"]'); }, true);
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.action !== 'add' || !e.promise) return;
    var da = origine;
    e.promise.then(function (r) {
      if (r && r.detail && r.detail.didError) return;
      vola(da, function () { apri(); aggiorna(); });
    }).catch(function () {});
  });

  /* il contenuto si prepara quando la pagina è ferma, così all'apertura è già pronto */
  window.addEventListener('load', function () {
    setTimeout(function () { (window.requestIdleCallback || setTimeout)(function () { if (!pronto) carica().then(omaggi).catch(function () {}); }, { timeout: 4000 }); }, 1800);
  });
})();
